import { switchAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
	switchAnatomy.keys,
);

export const Switch = defineMultiStyleConfig({
	baseStyle: (properties) => ({
		track: {
			_checked: {
				backgroundColor: (theme) =>
					theme.colors[properties.colorScheme][500] as string,
			},
			backgroundColor: (theme) =>
				theme.colors[properties.colorScheme][100] as string,
		},
	}),
	defaultProps: { colorScheme: "primary" },
});
